/**
 * @file Writes a chart bar total as compact currency with one decimal place
 * in millions, such as `"$11.1M"`, and whole thousands, such as `"$500K"`.
 * Consumer: the total above each "Sales credit by month" bar. Thresholds and
 * rounding are those of `analyticsCompactCurrencyText`.
 */
import { analyticsCompactCurrencyText } from './analyticsCompactCurrencyText';

export const analyticsBarTotalText = (decimal: string): string =>
  analyticsCompactCurrencyText(decimal, { millionPlaces: 1 });
